import { render } from "./Column202411.vue?vue&type=template&id=886c9208&scoped=true"
import script from "./Column202411.vue?vue&type=script&lang=js"
export * from "./Column202411.vue?vue&type=script&lang=js"

import "./Column202411.vue?vue&type=style&index=0&id=886c9208&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-886c9208"

export default script